export const PORTALS = {
  ADMIN: 'admin',
  ADVERTISER: 'advertiser',
};

const PORTAL_CONFIG = {
  [PORTALS.ADMIN]: {
    getBaseURL: () => process.env.API_URL,
    loginPath: '/admin/login',
    mePath: '/admin/me',
    mfaRequired: true,
    mfaIssuer: 'Sparks Admin',
  },
  [PORTALS.ADVERTISER]: {
    getBaseURL: () => process.env.ADVERTISER_API_URL,
    loginPath: '/advertiser/login',
    mePath: '/advertiser/me',
    // Optional: advertisers can set a Second Factor up from their settings menu.
    mfaRequired: false,
    mfaIssuer: 'Sparks Advertiser',
  },
};

export function getPortalConfig(portal) {
  return PORTAL_CONFIG[portal];
}

export function getLoginPath(portal) {
  return PORTAL_CONFIG[portal].loginPath;
}

export function portalFromPath(pathname = '') {
  return pathname.startsWith('/advertiser')
    ? PORTALS.ADVERTISER
    : PORTALS.ADMIN;
}
